import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

export class Alert {
    id: string;
    type: AlertType;
    message: string;
    autoClose: boolean;
    keepAfterRouteChange: boolean;
    fade: boolean;
    verticalPos: MatSnackBarVerticalPosition;
    horizontalPos: MatSnackBarHorizontalPosition;

    constructor(init?: Partial<Alert>) {  
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success = "success",
    Error = "error",
    Info = "info",
    Warning = "warning"
}